import React from 'react'
import Flex from '../Flex'
import Text from '../Text'

import { LabelNotificationProps } from './Label.types'

const LabelNotification: React.FC< LabelNotificationProps > = ({
  backgroundColor = 'red50',
  color = 'white',
  width = 'fit-content',
  height = '14px',
  children,
}) => (
  <Flex
    alignItems='center'
    justifyContent='center'
    borderRadius='16px'
    backgroundColor={backgroundColor}
    color={color}
    height={height}
    paddingX='4px'
    width={width}
  >
    <Text variant='small' weight='bold' color='white'>
      {children}
    </Text>
  </Flex>
)

export default LabelNotification
